/* ARWAY catalog helpers — exact storefront product matching */
(function () {
  'use strict';
  if (window.ArwayCatalog) return;

  var cachePromise = null;
  var KNOWN_CC = [40,49,50,70,90,100,110,125,140,150,200,250,300,350,400,450,500,550,600,650,700,750,800,850,900,1000];

  function rootPath() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    root = root || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function normalize(value) {
    return String(value == null ? '' : value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }

  function tagsText(product) {
    if (!product) return '';
    var tags = product.tags;
    if (Array.isArray(tags)) return tags.join(' ');
    return tags || '';
  }

  function text(product) {
    return normalize([
      product && product.title,
      product && product.product_type,
      product && product.vendor,
      tagsText(product),
      product && product.body_html
    ].filter(Boolean).join(' '));
  }

  function engineCC(product) {
    var source = text(product);
    var explicit = source.match(/(?:^|[^0-9])(\d{2,4})\s*(?:cc|cmc|cm3|cm³)(?:[^a-z0-9]|$)/i);
    if (explicit) {
      var n = Number(explicit[1]);
      if (n >= 35 && n <= 1500) return n;
    }

    var title = normalize(product && product.title);
    if (/\belectric\b|\belectric\b|\b\d{2,5}\s*w\b|\b\d{2,3}\s*v\b/.test(title)) return null;
    for (var i = 0; i < KNOWN_CC.length; i++) {
      var cc = KNOWN_CC[i];
      var re = new RegExp('(?:^|[^0-9])' + cc + '(?:[^0-9]|$)');
      if (re.test(title)) return cc;
    }
    return null;
  }

  function hasGasMarker(product) {
    var source = text(product);
    return /\bbenzina\b|\bpetrol\b|\bgasoline\b|\b4t\b|\b2t\b/.test(source);
  }

  function isElectric(product) {
    /* A petrol vehicle can have electric START. A real combustion displacement wins. */
    if (engineCC(product) != null) return false;
    var source = text(product);
    var explicitElectric = /\belectric\b|\belectric\b|\bbrushless\b|\b\d{2,5}\s*w\b|\b\d{2,3}\s*v\b/.test(source);
    return explicitElectric && !hasGasMarker(product);
  }

  function fuel(product) {
    if (engineCC(product) != null || hasGasMarker(product)) return 'gas';
    if (isElectric(product)) return 'electric';
    return 'unknown';
  }

  function vehicleType(product) {
    var type = normalize(product && (product.product_type || product.type));
    var title = normalize(product && product.title);
    var source = normalize([type, title, tagsText(product)].join(' '));

    /* Stop accessories that merely mention ATV/Moto from entering the vehicle finder. */
    if (/accesor|piese|anvelop|camera de aer|ulei|filtru|casca|manus|ochelari|geaca|bluza|protectie|incarcator|baterie|chinga|demaror|portbagaj/.test(type)) return 'other';

    if (/\butv\b|\bbuggy\b/.test(source)) return 'utv';
    if (/motocross|dirt\s?bike|pit\s?bike/.test(source)) return 'motocross';
    if (/(^|\s)atv(\s|$)|quad/.test(source)) return 'atv';
    return 'other';
  }

  function isKids(product) {
    return /\bcopii\b|\bcopil\b|\bjunior\b|\bkids?\b|\byouth\b/.test(text(product));
  }

  function ageMatch(product, age) {
    if (!age || age === 'any') return true;
    var cc = engineCC(product);
    var electric = isElectric(product);
    var kids = isKids(product);

    if (age === '3-8') return kids && (electric || cc == null || cc <= 110);
    if (age === '9-13') return kids ? (electric || cc == null || cc <= 150) : (cc != null && cc >= 90 && cc <= 150);
    if (age === '14-17') return electric ? true : (cc == null ? !kids : cc >= 110 && cc <= 300);
    if (age === '18+') return !kids || (cc != null && cc >= 250);
    return true;
  }

  function minPrice(product) {
    var variants = product && Array.isArray(product.variants) ? product.variants : [];
    var prices = variants.map(function (variant) { return Number(variant.price); }).filter(function (n) { return Number.isFinite(n); });
    return prices.length ? Math.min.apply(Math, prices) : NaN;
  }

  function compareAtPrice(product) {
    var variants = product && Array.isArray(product.variants) ? product.variants : [];
    var values = variants.map(function (variant) { return Number(variant.compare_at_price); }).filter(function (n) { return Number.isFinite(n); });
    return values.length ? Math.max.apply(Math, values) : NaN;
  }

  function productUrl(product) {
    var handle = product && product.handle ? String(product.handle).trim() : '';
    return handle ? rootPath() + 'products/' + encodeURIComponent(handle) : rootPath() + 'collections/all';
  }

  function imageUrl(product) {
    if (!product) return '';
    if (product.image && product.image.src) return product.image.src;
    if (Array.isArray(product.images) && product.images[0]) return product.images[0].src || product.images[0];
    return '';
  }

  function formatPrice(value) {
    var n = Number(value);
    if (!Number.isFinite(n)) return '';
    return new Intl.NumberFormat('ro-RO', { style: 'currency', currency: 'RON', maximumFractionDigits: 0 }).format(n);
  }

  function load() {
    if (cachePromise) return cachePromise;

    var endpoints = [
      rootPath() + 'products.json?limit=250',
      rootPath() + 'collections/all/products.json?limit=250'
    ];

    function request(index) {
      if (index >= endpoints.length) return Promise.reject(new Error('catalog-unavailable'));
      var url = new URL(endpoints[index], window.location.origin);
      return fetch(url.toString(), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('catalog-' + response.status);
        return response.json();
      }).then(function (data) {
        var products = data && Array.isArray(data.products) ? data.products : [];
        if (!products.length) throw new Error('catalog-empty');
        return products;
      }).catch(function () {
        return request(index + 1);
      });
    }

    cachePromise = request(0)
      .then(function (products) {
        return products.filter(function (product) {
          return product && product.handle && vehicleType(product) !== 'other';
        });
      })
      .then(function (products) {
        if (!products.length) throw new Error('vehicle-catalog-empty');
        return products;
      })
      .catch(function (error) {
        cachePromise = null;
        throw error;
      });

    return cachePromise;
  }

  window.ArwayCatalog = {
    load: load,
    normalize: normalize,
    text: text,
    engineCC: engineCC,
    fuel: fuel,
    isElectric: isElectric,
    vehicleType: vehicleType,
    isKids: isKids,
    ageMatch: ageMatch,
    minPrice: minPrice,
    compareAtPrice: compareAtPrice,
    productUrl: productUrl,
    imageUrl: imageUrl,
    formatPrice: formatPrice
  };
})();
